import type {
  ImportOrderLineMatchStatus,
  ImportOrderSource,
  ImportOrderStatus,
} from "@/server/platform/db/schema/inventory";

export const IMPORT_ORDER_STATUS_LABELS: Record<ImportOrderStatus, string> = {
  draft: "ຮ່າງ",
  ordered: "ສັ່ງແລ້ວ",
  at_carrier: "ຢູ່ຂົນສົ່ງ",
  partially_received: "ຮັບບາງສ່ວນ",
  received: "ຮັບແລ້ວ",
  cancelled: "ຍົກເລີກ",
};

export const IMPORT_ORDER_STATUS_CLASS: Record<ImportOrderStatus, string> = {
  draft: "border-border bg-muted/40 text-foreground",
  ordered: "border-secondary/40 bg-secondary/10 text-secondary",
  at_carrier: "border-primary/40 bg-primary/10 text-secondary",
  partially_received: "border-accent/40 bg-accent/20 text-foreground",
  received: "border-leaf/40 bg-leaf/10 text-leaf",
  cancelled: "border-destructive/30 bg-destructive/10 text-destructive",
};

export const IMPORT_ORDER_SOURCE_LABELS: Record<ImportOrderSource, string> = {
  taobao: "Taobao",
  "1688": "1688",
  pinduoduo: "Pinduoduo",
  other: "ອື່ນໆ",
};

export const IMPORT_ORDER_SOURCE_CLASS: Record<ImportOrderSource, string> = {
  taobao: "border-orange-500/35 bg-orange-500/10 text-orange-900 dark:text-orange-200",
  "1688": "border-amber-600/35 bg-amber-500/10 text-amber-950 dark:text-amber-100",
  pinduoduo: "border-rose-500/35 bg-rose-500/10 text-rose-900 dark:text-rose-100",
  other: "border-border bg-muted/50 text-muted-foreground",
};

export const IMPORT_ORDER_CURRENCY_LABELS: Record<"CNY" | "LAK", string> = {
  CNY: "ຢວນ (CNY)",
  LAK: "ກີບ (LAK)",
};

export const IMPORT_ORDER_CURRENCY_OPTIONS = [
  { value: "LAK" as const, label: IMPORT_ORDER_CURRENCY_LABELS.LAK },
  { value: "CNY" as const, label: IMPORT_ORDER_CURRENCY_LABELS.CNY },
];

export function importOrderPriceUnitLabel(currency: string): string {
  return currency === "LAK" ? "LAK" : "CNY";
}

export const RECEIVABLE_IMPORT_STATUSES = new Set<ImportOrderStatus>([
  "ordered",
  "at_carrier",
  "partially_received",
]);

export const IMPORT_ORDER_STATUS_FILTERS: Array<{
  value: ImportOrderStatus | "all" | "overdue";
  label: string;
}> = [
  { value: "all", label: "ທັງໝົດ" },
  { value: "draft", label: "ຮ່າງ" },
  { value: "ordered", label: "ສັ່ງແລ້ວ" },
  { value: "at_carrier", label: "ຢູ່ຂົນສົ່ງ" },
  { value: "partially_received", label: "ຮັບບາງສ່ວນ" },
  { value: "received", label: "ຮັບແລ້ວ" },
  { value: "overdue", label: "ເກີນກຳນົດ" },
];

export const IMPORT_ORDER_LINE_MATCH_LABELS: Record<
  ImportOrderLineMatchStatus,
  string
> = {
  pending: "ລໍຖ້າຈັບຄູ່",
  matched: "ຈັບຄູ່ແລ້ວ",
  skipped: "ຂ້າມແລ້ວ",
};

export const IMPORT_ORDER_LINE_MATCH_CLASS: Record<
  ImportOrderLineMatchStatus,
  string
> = {
  pending: "border-amber-500/40 bg-amber-500/10 text-amber-950 dark:text-amber-100",
  matched: "border-leaf/40 bg-leaf/10 text-leaf",
  skipped: "border-border bg-muted/50 text-muted-foreground",
};

export function formatLakAmount(value: string | number): string {
  const n = typeof value === "string" ? Number(value) : value;
  if (!Number.isFinite(n)) return "—";
  return `${n.toLocaleString("lo-LA")} ₭`;
}
